module.exports = __webpack_public_path__ + "static/media/moon.399b1420.svg";